<template>
    <div class="orderDetail">
<!--        <el-card class="noprint">-->
<!--            <el-page-header @back="goBack" :content="`销售订单(${detail.settlementNo})`"></el-page-header>-->
<!--            <el-breadcrumb v-if="from == 'menu'" separator="/">-->
<!--                <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>订单管理</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>销售订单</el-breadcrumb-item>-->
<!--            </el-breadcrumb>-->
<!--        </el-card>-->
        <main class="content">
            <div class="quote mt20 mb60 pt10">
                <div class="clearfix" >
                    <div class="fl" style="font-size: 14px;float: left;font-weight: bold;line-height: 20px;">
                            <div><span>销售订单：</span><span >{{detail.settlementNo}}</span></div>
                            <div><span>创建时间：</span><span >{{detail.orderTime}}</span></div>
                            <div><a href="https://mro.tcmtc.com.cn/" style="color:#000">https://mro.tcmtc.com.cn</a></div>
                        </div>
                        <div class="fr" style="text-align: right"><img src="../../assets/logo3.png" alt="" width="300"/></div>
                    </div>
                    <div style="width:100%;" >
                        <div>
                            <table style="width: 500px !important;float:right;margin-right: 0 !important;font-size: 14px" border="1">
                                <tr style="width: 500px;" >
                                    <th colspan="2" style="padding: 3px; background: #dfdfdf">销售订单</th>
                                </tr>
                                <tr style="width: 500px;">
                                    <td style="padding: 3px;width: 120px;">客户编号：</td>
                                    <td style="padding: 3px;min-width: 300px;">{{detail.code}}</td>
                                </tr>
                                <tr style="width: 500px;">
                                    <td style="padding: 3px;width: 100px;">客户名称：</td>
                                    <td style="padding: 3px;min-width: 300px;">{{detail.companyName}}</td>
                                </tr>
                                <tr style="width: 500px;">
                                    <td style="padding: 3px;width: 90px;">订单日期：</td>
                                    <td style="padding: 3px;min-width: 300px;">{{detail.orderDate}}</td>
                                </tr>
                                <tr style="width: 500px;">
                                    <td style="padding: 3px;">订单金额：</td>
                                    <td style="padding: 3px;min-width: 300px;">{{MoneyFormat(detail.totalPrice, '￥', 2)+'元'}}</td>
                                </tr>
                            </table>
                            <div style="clear: both"></div>
                        </div>
                    </div>

                <div style="margin: 16px 0;clear: both;"><span style="font-size: 16px">订单进度查询：合同生效后，甲方及其采购人员可以通过鹏龙天创MRO平台(<a href="https://mro.tcmtc.com.cn/" style="color:#000">https://mro.tcmtc.com.cn</a>)查看订单处理进度，如有疑问或问题请联系为您服务的客服。</span></div>
                <div v-for="(order, orderNo, index) in detail.details" :key="orderNo">
                    <div style="margin-top: 16px;" ><span style="font-size: 14px;font-weight: bold;">{{ index + 1 }}. 子订单({{ orderNo }})</span></div>
                    <div style="margin-top: 3px;">
                        <table border="1" style="table-layout: fixed; width: 100%;font-size: 14px;">
                            <tr style="width: 100%;background: #dfdfdf;">
                                <th style="width: 60px">序号</th>
                                <th style="width: 120px">商品编码</th>
                                <th style="min-width: 150px">产品名称</th>
                                <th style="width: 130px">品牌</th>
                                <th style="width: 130px">规格型号</th>
                                <th style="width: 90px">数量</th>
                                <th style="width: 120px">未税单价</th>
                                <th style="width: 120px">含税单价</th>
                                <th style="width: 120px">未税总价</th>
                                <th style="width: 120px">含税总价</th>
                            </tr>
                            <tr style="width: 100%" v-for="(item,i) in order" :key="item.id">
                                <td align="center" style="padding: 0 5px; width: 50px;">{{i+1}}</td>
                                <td align="center" style="padding: 0 5px; width: 110px" >{{item.sku}}</td>
                                <td align="left"   style="padding: 0 5px; width: 200px" >{{"(" + item.supplier + ") " + (item.shortName ? item.shortName : item.name)}}</td>
                                <td align="center"  style="padding: 0 5px;width: 120px">{{item.brand}}</td>
                                <td align="center"  style="padding: 0 5px;width: 120px">{{item.model}}</td>
                                <td align="center"   style="padding: 0 5px;" >{{item.num}}</td>
                                <td align="right"   style="padding: 0 5px;">{{MoneyFormat(item.untaxedPrice, '￥', 6)+'元'}}</td>
                                <td align="right" style="padding: 0 5px;" >{{MoneyFormat(item.price, '￥', 6)+'元'}}</td>
                                <td align="right"  style="padding: 0 5px;" >{{MoneyFormat(item.totalUntaxedPrice, '￥', 2)+'元'}}</td>
                                <td align="right"  style="padding: 0 5px;">{{MoneyFormat(item.totalPrice, '￥', 2)+'元'}}</td>
                            </tr>
                            <tr style="width: 100%">
                                <th colspan="2"  style="width: 181px;background: #dfdfdf;">商品未税总价(CNY)：</th>
                                <td colspan="8" style="padding: 0 5px;">{{MoneyFormat(detail.subTotalUntaxedPrice[orderNo], '￥', 2)+'元'}}</td>
                            </tr>
                            <tr style="width: 100%">
                                <th colspan="2" style="width: 181px;background: #dfdfdf;">商品含税总价(CNY)：</th>
                                <td colspan="8" style="padding: 0 5px;" >{{MoneyFormat(detail.subTotalPrice[orderNo], '￥', 2)+'元'}}</td>
                            </tr>
                        </table>
                    </div>
                    <div><span style="font-size: 12px">说明：本合同金额不包括现场服务费及安装费用，合同中明确包含“现场服务费”除外。</span></div>
                </div>
                <div style="margin-top: 16px;" ><span style="font-size: 14px;font-weight: bold;">{{ subDetailCount + 1 }}. 销售订单总价</span></div>
                <div style="margin-top: 3px;">
                    <table border="1" style="table-layout: fixed; width: 100%;font-size: 14px;">
                        <tr style="width: 100%">
                            <th colspan="2"  style="width: 181px;background: #dfdfdf;">商品未税总价(CNY)：</th>
                            <td colspan="8" style="padding: 0 5px;">{{MoneyFormat(detail.totalUntaxedPrice, '￥', 2)+'元'}}</td>
                        </tr>
                        <tr style="width: 100%">
                            <th colspan="2" style="width: 181px;background: #dfdfdf;">商品含税总价(CNY)：</th>
                            <td colspan="8" style="padding: 0 5px;" >{{MoneyFormat(detail.totalPrice, '￥', 2)+'元'}}</td>
                        </tr>
                    </table>
                </div>
                <div><span style="font-size: 12px">说明：本合同金额不包括现场服务费及安装费用，合同中明确包含“现场服务费”除外。</span></div>

                <div style="margin-top: 16px;"><span style="font-size: 14px;font-weight: bold;">{{ subDetailCount + 2 }}. 其他费用</span></div>
                <div style="margin-top: 3px;font-size: 14px">

                    <table border="1" style="table-layout: fixed; width: 100%; font-size: 14px">
                        <tr style="width: 100%">
                            <th colspan="2" style="width: 185px;background: #dfdfdf;">运费(CNY)：</th>
                            <td  colspan="8" style="padding: 0 5px;">{{MoneyFormat(detail.freight, '￥', 2)+'元'}}</td>
                        </tr>
                    </table>
                </div>
                <div style="margin-top: 16px;"><span style="font-size: 14px;font-weight: bold;">{{ subDetailCount + 3 }}. 开票资料信息</span></div>
                <div style="margin-top: 3px;">

                    <table border="1" style="table-layout: fixed; width: 100%;font-size: 14px">
                        <tr style="width: 100%">
                            <th colspan="2" style="width: 185px;background: #dfdfdf;">公司名称：</th>
                            <td  colspan="3" style="padding: 0 5px;">{{detail.invoice.companyName}}</td>
                            <th  colspan="2" style="width: 185px;background: #dfdfdf;">发票类型：</th>
                            <td  colspan="3" style="padding: 0 5px;">{{detail.invoice.showType}}</td>

                        </tr>
                        <tr style="width: 100%">
                            <th colspan="2" style="width: 185px;background: #dfdfdf;">开户银行：</th>
                            <td colspan="3" style="width: 467px;padding: 0 5px;">{{detail.invoice.bankName}}</td>
                            <th colspan="2" style="width: 185px;background: #dfdfdf;">注册电话：</th>
                            <td colspan="3" style="width: 467px;padding: 0 5px;">{{detail.invoice.registeredTel}}</td>

                        </tr>
                        <tr style="width: 100%">
                            <th colspan="2" style="width: 185px;background: #dfdfdf;">银行账号：</th>
                            <td colspan="3" style="padding: 0 5px;">{{detail.invoice.bankAccount}}</td>
                            <th colspan="2" style="width: 185px;background: #dfdfdf;">注册地址：</th>
                            <td colspan="3" style="padding: 0 5px;">{{detail.invoice.registeredAddress}}</td>

                        </tr>
                        <tr style="width: 100%">
                            <th colspan="2" style="width: 185px;background: #dfdfdf;">公司税号：</th>
                            <td colspan="3" style="width: 367px;padding: 0 5px;">{{detail.invoice.companyTaxNo}}</td>
                            <th colspan="2" style="width: 185px;background: #dfdfdf;">备注信息：</th>
                            <td colspan="3" style="width: 467px;padding: 0 5px;">-</td>

                        </tr>
                    </table>
                </div>
                <div style="margin-top: 16px;"><span style="font-size: 14px;font-weight: bold;">{{ subDetailCount + 4 }}. 邮寄信息</span></div>
                <div style="margin-top: 3px;">

                    <table border="1" style="table-layout: fixed; width: 100%;font-size: 14px">
                        <tr style="width: 100%">
                            <th colspan="2" style="width: 185px;background: #dfdfdf;">收件人：</th>
                            <td  colspan="3" style="padding: 0 5px;">{{detail.address.consignee ? detail.address.consignee : '-'}}</td>
                            <th  colspan="2" style="width: 185px;background: #dfdfdf;">联系电话：</th>
                            <td  colspan="3" style="padding: 0 5px;">{{detail.address.mobile ? detail.address.mobile : '-'}}</td>
                        </tr>
                        <tr style="width: 100%">
                            <th colspan="2" style="width: 185px;background: #dfdfdf;">邮寄地址：</th>
                            <td colspan="8" style="width: 467px;padding: 0 5px;">{{detail.address.address ? detail.address.address : '-'}}</td>
                        </tr>
                    </table>
                </div>
                <div style="margin-top: 16px;font-size: 12px;">
                    <div>备注：</div>
                    <div>1.在中华人民共和国境内，对于净值超过人民币300元的订单我们提供免费寄送服务。对于订货金额低于人民币300元的订单，我们将收取每单40元的送货费。</div>
                    <div>2.对于错订的物品，我们将收取10%的退货费，最少100元起。</div>
                    <div>3.货物运输至中国境内客户指定地点。</div>
                    <div>4.新疆、西藏、青海等偏远地区的最小订单金额、运费及货期以实际报价阶段为准。</div>
                </div>
            </div>

        </main>

    </div>
</template>

<script>

    // import html2canvas from "html2canvas";
    // import printJS from "print-js";

    export default {
        data() {
            return {
                id: "",
                detail: {},
                child:{
                    settlementNo:"",
                     totalPrice:"",
                     createTime:"",
                    code:"",
                    companyName:"",
                    id:"",
                    from:""
                },
                loading: false,
                loading1: false,
                total: 0,
                pageSize: 10,
                currentPage: 1,
                tableData: [],
                reviewVisible:false,
                reviewForm: {
                    name:"",//收货人
                    pass:true,
                    reason: "",
                    workflowId:"",
                    step:"",
                    orderId:"",
                    totalPrice:""
                },
                infoData:{},
                invoiceData: [],//发票信息
                deliverData: [],//发票及货物接收信息
                orderData:[],//销售订单
                taxData: [],//含税价格
                proData: [],//产品信息
                allData: []
            }
        },
        computed: {
            subDetailCount() {
                return Object.keys(this.detail.details).length;
            }
        },
        methods: {

            info() {
                let that = this;
                this.$axios.post("/admin/product/order/saleOrderDetail",{id:this.id})
                .then(function(response) {
                    let resp = response.data;
                    if(resp.header.status == 0) {
                        that.detail = resp.data;
                    }
                }).catch(function() {
                });
            },

            goBack() {
                this.$router.go(-1);
            },
        },
        mounted(){

        },
        created() {
            let paramsStore;
            const params = sessionStorage.getItem("params");
            if(params) {
                paramsStore = JSON.parse(params);
            }
            const { id } = JSON.stringify(this.$route.params)== "{}"?paramsStore:this.$route.params;
            this.id = id;
            this.info();
        },

    }
</script>
<style lang="scss" scoped>
    .hiddenClass {
        display: none !important;
    }
    .el-table-order{
        max-width: 551px !important;
        width: 551px !important;
        margin-right: 10px;
    }
    ::v-deep .tableBaseInfo {
        .hiddenClass {
            display: none !important;
        }

    }

    ::v-deep .el-table th {
        border-color: black !important;

    }
    ::v-deep .el-table td {
        border-color: black !important;

    }
    ::v-deep .el-table--group,
    ::v-deep .el-table--border {
        border: 0.5px solid black !important;
    }
    ::v-deep .no-header-only.el-table--border {
        border-top: 0.5px solid black !important;
    }
    ::v-deep .no-header.el-table--border {
        border-top: 0.5px solid black !important;
    }
    /*.el-table-o{*/
    /*    max-width: 1100px !important;*/
    /*    width: 1100px !important;*/
    /*    margin-right: 0px;*/
    /*}*/
    .el-table-o{

        margin-right: 0px;
    }

    .quote {
        min-width: 1200px;
        margin: 0 auto;
        background-color: white;
    }
    .quote table {
        border-collapse: collapse;
    }
    .quote .thead .th {
        height: 38px;
        line-height: 38px;
        text-align: center;
        font-weight: bold;
        color: #333;
        font-size: 16px;
        border-right: 1px solid #AED8FF  !important;
        display: inline-block;
    }
    .pt10{
        padding: 10px;
    }

</style>